import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../components/auth/LoginForm';

const Login: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const params = new URLSearchParams(location.search);
      const redirect = params.get('redirect');
      navigate(redirect || '/');
    }
  }, [isAuthenticated, navigate, location.search]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col justify-center">
      <div className="mx-auto w-full max-w-md">
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
